;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import { FilterPillProps } from './types';
export const FilterPill = ({
  isActive,
  label,
  onClick,
  className
}: FilterPillProps) => {
  return <button className={clsx('text-h9 flex shrink-0 rounded-[50px] border px-4 py-2 font-bold', {
    'bg-gray-600': isActive,
    'bg-white': !isActive,
    'border-gray-200': !isActive,
    'border-gray-600': isActive,
    'text-white': isActive,
    'text-gray-600': !isActive,
    'transition duration-150 ease-in-out hover:opacity-60': !isActive
  }, className)} onClick={onClick} data-sentry-component="FilterPill" data-sentry-source-file="index.tsx">
      {label}
    </button>;
};